export default __webpack_public_path__ + "static/media/SLIDER-Vikkymore-Foundation.f4bda0d7.png";